import routesMatch from 'rise-ui/utils/routes-match.js';

export default function routeInfoHasRoute(routeInfo, route) {
  let result = false;
  while (!result && routeInfo) {
    if (routesMatch(routeInfo.name, route)) {
      result = true;
    }
    routeInfo = routeInfo.parent;
  }
  return result;
}
